module.exports = __webpack_public_path__ + "static/img/MO@2x.8337e91e.jpg";